import { render, staticRenderFns } from "./AnimatingButton.vue?vue&type=template&id=b4ff293c"
import script from "./AnimatingButton.vue?vue&type=script&lang=js"
export * from "./AnimatingButton.vue?vue&type=script&lang=js"
import style0 from "./AnimatingButton.vue?vue&type=style&index=0&id=b4ff293c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports